import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

interface FieldHelpProps {
  baseKey: string;
  className?: string;
}

interface HelpBlockProps {
  label: string;
  body: string;
  muted?: boolean;
}

function HelpBlock({ label, body, muted = false }: HelpBlockProps) {
  return (
    <div className={muted ? 'rounded-md bg-muted/50 p-2' : undefined}>
      <p className="text-xs font-medium">{label}</p>
      <p className="whitespace-pre-line text-sm text-muted-foreground">{body}</p>
    </div>
  );
}

export function FieldHelp({ baseKey, className }: FieldHelpProps) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={t('onboarding.help.aria')}
          className={[
            'h-11 w-11 -my-2.5',
            'inline-flex items-center justify-center rounded-md transition-colors',
            'text-muted-foreground hover:text-foreground hover:bg-muted',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <HelpCircle className="h-4 w-4" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="space-y-3 text-left">
        <HelpBlock label={t('onboarding.help.label_what')} body={t(`${baseKey}_help_what`)} />
        <HelpBlock label={t('onboarding.help.label_bot')} body={t(`${baseKey}_help_bot`)} />
        <HelpBlock
          label={t('onboarding.help.label_example')}
          body={t(`${baseKey}_help_example`)}
          muted
        />
      </PopoverContent>
    </Popover>
  );
}
